import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentForgotPassword = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">9.Forgot Password</h2>
            <div>
                <p> If you forget the Login password for the developer portal, you can navigate to the Login page and click on <span className="font-bold">Forgot Password</span> option highlighted in red text hyperlink as shown in below screenshot.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/reset_password_1.png"} />
            </div>

            <div>
                <p>Please follow the steps given below to Reset your login Password:</p>
                <p><span className="font-bold">Step 1:</span> Click on Forgot Password to land on to the <span className="font-bold">Reset Password</span> screen as shown in below. Enter the valid username and click on <span className="font-bold">Get OTP</span> button.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/reset_password_username.png"} />
            </div>

            <div>
                <p><span className="font-bold">Step 2:</span> Once you click on <span className="font-bold">Get OTP</span> button you would be redirected to the screen as shown in screenshot given below </p>
                <img className="pic" src={staticAssetsUrl + "user_manual/reset_password_marketplace.png"} />
            </div>

            <div>
                <h3><span className="font-bold">Note:-</span> You have to enter your registered username</h3>
                <p><span className="font-bold">Step 3:</span> Enter the OTP sent to your registered email ID.</p>
                <p><span className="font-bold">Step 4:</span> Enter New password as per your choice and also re-enter the same New password in Confirm New Password Text field. </p>
                <p><span className="font-bold">Step 5:</span> Click on <span className="font-bold">Reset Password</span> button.</p>
            </div>

            <div>
                <p>Password will be reset successfully post following all 5 steps mentioned above. You would be re-directed to the Login page where you can enter the Username and new password for logging into the developer portal.</p>
            </div>

        </div>
    )
}

export default ContentForgotPassword;